<template>
  <div class="component-container">
    <InfoContainer
      id="basicForm"
      :infoTitle="lendingInfo['infoTitle']"
      :contentConfig="lendingInfo['infoContent']"
    >
      <template #basicInfo>
        <!-- 编辑付款 -->
        <div class="detail-one" style="padding-left:0 !important">
          <div class="detail-top">
            <div class="detail-title">相关信息</div>
          </div>
          <div class="detail-content">
            <CommonDetail :configArray="detailConfig['column']" :initValue="detailData" />
          </div>
        </div>

        <div class="detail-one" style="padding-left:0 !important">
          <div class="detail-top">
            <div class="detail-title">
              本次核销信息
              <!-- <span class="title-tips"
                >（{{
                  detailData.writeOff == 0
                    ? "未核销"
                    : `核销人员：${detailData.writeoffUserName}，核销时间:${detailData.writeoffTime}`
                }}）</span
              > -->
            </div>
          </div>
          <div class="detail-content">
            <CommonDetail
              :configArray="detailConfigTwo"
              :initValue="detailData"
            />

            <div class="detail-content stone-con">
              <template v-for="(item, index) in detailData.paymentDetailList">
                <CommonDetail
                  :key="index"
                  class="stone-detail-one"
                  :configArray="collectionConfig"
                  :initValue="item"
                />
              </template>
            </div>
          </div>
        </div>

        <!-- <CommonDetail
          v-if="isDetail"
          :configArray="basicInfoFormConfig"
          :initValue="formData"
        /> -->
      </template>
    </InfoContainer>
    <InfoContainer
      style="margin-top: 20px"
      :infoTitle="`第1批 / 第${detailData.paymentBatch}笔 付款`"
      :contentConfig="lendingDetailInfoConfig['infoContent']"
    >
      <template #basicInfo>
        <CommonDetail :configArray="investInfo" :initValue="detailData" />
      </template>
      <template #innerDetail>
        <el-table :data="detailData.innerList" border style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="50">
          </el-table-column>
          <el-table-column align="center" property="moneyType" label="款项类型">
            <template slot-scope="scope">
              <div class="money-type" v-if="scope.row.dictMainOutlayType == 2">
                卖方保证金
              </div>
              <div class="money-type" v-else>
                {{ scope.row.outlayTypeStr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="outlayAmount"
            label="应收金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.outlayAmount)) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="innerPayment"
            label="当前可内扣金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.innerPayment)) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="innerMoney"
            label="本次内扣金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.innerMoney)) }}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #rentTable>
        <el-table :data="detailData.rentplanList" border style="width: 100%">
          <el-table-column align="center" property="issue" label="期数">
          </el-table-column>
          <el-table-column align="center" property="rentDay" label="还款日">
            <template slot-scope="scope">
              {{
                `${scope.row.rentDay
                  .toString()
                  .slice(0, 4)}年${scope.row.rentDay
                  .toString()
                  .slice(4, 6)}月${scope.row.rentDay.toString().slice(6, 8)}日`
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="expectedRent"
            label="每期保理首付款及保理首付款使用费合计额"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.expectedRent)) }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="principal" label="每期保理首付款">
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.principal)) }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="interest" label="每期保理首付款使用费">
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.interest)) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="residualPrincipal"
            label="剩余保理首付款"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.residualPrincipal)) }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="cashFlow" label="现金流量">
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.cashFlow)) }}
            </template>
          </el-table-column>
        </el-table>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import { lendingDetail } from "@/api/factoring/factoring";
import Accessory from "@/components/accessoriesother/accessory";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommonDetail from "@/components/commonDetail/commonDetail";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";

import {
  
  detailConfig,
  
} from "../config.js";
export default {
  name: "CommonForm",
  mixins: [workFlow, util],
  data() {
    return {
      // initParam: {auditStatus: 2},
      // bankParam: { custId },
      virtualId: "",
      initParam: {},
      contractParam: { isInvest: 1 },
      bankParam: {},
      planParam: {},
      formOneData: {},
      formTwoData: {},
      tableData: [],
      rentList: [],
      planData: {},
      lendingInfo: {
        infoTitle: "付款信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },

      // 应付款详情
      detailData: {},
      detailConfig: detailConfig(),
      detailConfigTwo: [
        {
          label: "款项标题",
          prop: "moneyTitle",
          span: "12",
        },
        {
          label: "款项类型",
          prop: "moneyTypeStr",
          span: "12",
        },
        {
          label: "应付金额",
          prop: "investShouldMoneyStr",
          span: "12",
        },
        {
          label: "计划付款日期",
          prop: "planPayDate",
          span: "12",
        },
        {
          label: "客户收款账号",
          prop: "accountName",
          span: "12",
        },
      ],
      collectionConfig: [
        {
          label: "付款账号",
          prop: "paymentAccountStr",
          span: "14",
        },
        {
          label: "付款金额",
          prop: "payMoney",
          span: "14",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "付款日期",
          prop: "payDate",
          span: "14",
        },
      ],
      lendingDetailInfoConfig: {
        infoTitle: "付款信息",
        infoContent: [
          {
            title: "本批次付款信息",
            prop: "basicInfo",
          },
          {
            title: "内扣明细",
            prop: "innerDetail",
          },
          // {
          //   title: "还款计划表",
          //   tips: "(此处“还款日”以“计划付款日期”为参考；实际还款计划表，请在“投后—还款计划”中查看)",
          //   prop: "rentTable",
          // },
        ],
      },
      investInfo: [
        {
          label: "本笔付款金额",
          span: "12",
          prop: "investMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        // {
        //   label: "计划付款日期",
        //   span: "12",
        //   prop: "rentDate",
        // },
        {
          label: "内扣合计金额",
          span: "12",
          prop: "innerCost",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "实际应付金额",
          span: "12",
          prop: "investShouldMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "支付方式",
          span: "12",
          prop: "payType",
          formatter: (label, value) => {
            return value == 0
              ? "电汇"
              : value == 1
              ? "银行承兑汇票"
              : value == 2
              ? "商票"
              : "其它";
          },
        },
        {
          label: "补充说明",
          span: "24",
          prop: "remarks",
        },
      ],
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    // 传入的详细数据
    bindData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    Accessory,
    CommonSelect,
    CommonDetail,
    InfoContainer,
  },
  watch: {
    tableData: {
      handler(newData, oldData) {
        this.$forceUpdate();
        this.$nextTick();
      },
      deep: true,
    },
    bindData: {
      handler(newData, oldData) {
        if (newData.id && newData.id != "") {
          this.dealDetailData(newData);
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    // 详细页不执行查询详情操作
    if (this.$route.params.id && !this.isDetail) {
      // 查询投放管理详细信息
      // this.queryDetailData()
      this.titleName = "编辑";
      this.$forceUpdate();
    }
  },
  methods: {
    async queryDetailData() {
      let id = this.$route.params.id;
      let res = await lendingDetail({ id });
      if (res.data.code == 200) {
        this.dealDetailData(res.data.data);
      }
    },

    async dealDetailData(detailData) {
      let totalCost = 0;
      detailData.innerCost = 0;
      detailData.innerList.map((i) => {
        totalCost= floatAdd(totalCost,Number(i.innerMoney)) ;
      });
      if (detailData.paymentDetailList.length > 0) {
        detailData.paymentDetailList.map((item) => {
          if (JSON.stringify(item.custBankBl) != "{}") {
            item.paymentAccountStr = `${item.custBankBl.bankAccountName} ${item.custBankBl.bankOpenName} ${item.custBankBl.bankNo}`;
          } else {
            item.paymentAccountStr = "暂无银行信息";
          }
        });
      }
      detailData.innerList.map((i) => {
        detailData.innerCost= floatAdd(detailData.innerCost,Number(i.innerMoney)) ;
      });

      this.detailData = {
        ...detailData,
        paymentBatch: detailData.paymentBatch,
        innerCost: detailData.innerCost,
        managerUserName: detailData.managerUserName,
        assistUserName: detailData.assistUserName,
        // sellerCustName: this.investData.contractManage.sellerCustName,
        // sellerCustId: this.investData.contractManage.sellerCustId,
        accountingEntity: detailData.formAccountingEntityStr,
        // contractName: this.investData.contractManage.name?this.investData.contractManage.name: '',
        investBatch: `第${detailData.investBatch}批`,
        planPayDate: detailData.planPayDate,
        investMoney: detailData.investMoney,
        moneyType: detailData.moneyType,
        moneyTypeStr: detailData.moneyType == 1 ? "保证金退还" : "资金投放",
        accountName: `${detailData.custBankBl.bankAccountName} ${detailData.custBankBl.bankOpenName} ${detailData.custBankBl.bankNo}`,
        moneyTitle: `${detailData.projectName}/第${detailData.investBatch}批`,
        writeOff: detailData.isWriteoff,
        innerList: detailData.innerList,
        investAllMoney:detailData.investAllMoney,
        totalCost: `${this.getMoney(totalCost)}元`,
        investShouldMoneyStr: `${this.getMoney(
          detailData.investShouldMoney
        )}元`,
        investShouldMoney: detailData.investShouldMoney,
        paymentDetailList: detailData.paymentDetailList,
        writeoffUserName: detailData.writeoffUserName,
        writeoffTime: detailData.writeoffTime,
        contractName: detailData.contractName,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  /deep/.info-container-temp .box-card .detail-one {
    padding: 0px 50px !important;
  }
  .green-word {
    font-weight: 400;
    font-style: normal;
    color: #33ccb0;
  }
}
</style>